export default "images/assets.png";